import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom";

const CraftFiltersSearch = ({activeBlock}) => {

  const {pathname} = useLocation();
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');
  const onInputHandler = (e) => setSearchValue(e.target.value)

  useEffect(() => {
    const params = new URLSearchParams();

    if (searchValue !== '') {
      params.set('search', searchValue)
    } else {
      params.delete('search')
    }

    navigate(`${pathname}?${params.toString()}`, { replace: true });

  }, [searchValue])

  useEffect(() => {
    setSearchValue('');
  }, [activeBlock])

  return (
    <input
        type="text"
        className="craft-select__form-input"
        placeholder={activeBlock}
        value={searchValue}
        onInput={onInputHandler}
      />
  )
}

export default CraftFiltersSearch
